





import { Component, Vue } from 'vue-property-decorator';

import Logo from '@/components/common/logo.vue';

@Component({
  components: {
    Logo,
  },
})
export default class SideBarTopComponent extends Vue {
}
